/* eslint-disable linebreak-style */
import React from 'react';
import MainLayout from 'components/MainLayout';

export const App = () => {
  return <MainLayout />
}
